import { FormatCurrencyOptions } from "../types";

const DEFAULT_CURRENCY_SYMBOL = "$";

const CURRENCY_LOCALE_MAP: Record<string, string> = {
  "$": "en-US",
  "£": "en-GB",
  "€": "de-DE",
  "¥": "ja-JP",
  "₩": "ko-KR",
  "₹": "en-IN",
  "R$": "pt-BR",
  "A$": "en-AU",
  "C$": "en-CA",
};

const getLocale = (currencyDisplay: string): string => {
  return CURRENCY_LOCALE_MAP[currencyDisplay?.trim()] ?? "en-US";
};

const getNumericAmount = (amount: number | string): number => {
  if (typeof amount === "number") {
    return amount;
  }

  return Number.parseFloat(amount);
};

const formatAmount = (amount: number, locale: string): string => {
  return Math.abs(amount).toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const getCurrencySymbol = (currencyDisplay: string): string => {
  const trimmedCurrencyDisplay = currencyDisplay?.trim();
  return trimmedCurrencyDisplay || DEFAULT_CURRENCY_SYMBOL;
};

export const formatCurrency = (
  amount: number | string,
  currencyDisplay: string,
  options?: FormatCurrencyOptions
): string => {
  const symbol = getCurrencySymbol(currencyDisplay);
  const locale = getLocale(currencyDisplay);
  const numericAmount = getNumericAmount(amount);

  if (!Number.isFinite(numericAmount)) {
    const sign = numericAmount < 0 ? "-" : "";
    return `${sign}${symbol}${typeof amount === "string" ? amount : ""}`;
  }

  if (options?.accounting && numericAmount < 0) {
    return `(${symbol}${formatAmount(numericAmount, locale)})`;
  }

  const sign = numericAmount < 0 ? "-" : "";
  return `${sign}${symbol}${formatAmount(numericAmount, locale)}`;
};
